import {commonCrudOption} from '@/const/crud/commonOption'
import {getToken} from '@/utils/auth'

export const getTableOption = (self) => ({
  ...commonCrudOption,
  menuWidth: 120,
  labelWidth: 130,
  searchLabelWidth: 90,
  searchIndex: 2,
  searchMenuSpan: 6,
  delBtn: false,
  editBtn: false,
  column: [
    {
      label: '标准名称',
      prop: 'name',
      overHidden: true,
      width: 140,

      order: 130,
      rules: [
        {required: true, message: '请输入收费标准名称', trigger: 'blur'}
      ]
    },
    {
      label: '标准名称',
      prop: 'conductName',
      hide: true,
      display: false,
      search: true,
      searchOrder: 31,
      searchSpan: 6,
      placeholder: ' '
    },
    {
      label: '科目名称',
      prop: 'bindAccountName',
      bind: 'account.name',
      overHidden: true,
      width: '140',
      display: false
    },
    {
      label: '科目名称',
      prop: 'accountCode',
      overHidden: true,
      width: '140',
      hide: true,
      type: 'tree',
      order: 120,
      props: {
        children: 'children',
        label: 'name',
        value: 'code'
      },
      dicUrl: process.env.VUE_APP_BASE_API + '/api/finance/account/type/tree?includeAccount=true&includeValid=true',
      dicHeaders: {
        Authorization: getToken()
      },
      dicFormatter: (res) => {
        const notAccountDisable = (arr) => {
          arr.forEach(item => {
            item.disabled = item.type !== 'account'
            item.children && notAccountDisable(item.children)
          })
        }
        notAccountDisable(res.data)
        return res.data
      },
      rules: [
        {required: true, message: '请选择收费科目', trigger: 'blur'}
      ]
    },
    {
      label: '科目状态',
      prop: 'accountEnabled',
      bind: 'account.enabled',
      width: 120,
      display: false,
      type: 'radio',
      dicData: [
        {label: '正常', value: 1},
        {label: '封存', value: 0}
      ]
    },
    {
      label: '周期性标准',
      width: '110',
      prop: 'isPeriodic',
      overHidden: true,

      search: true,
      searchOrder: 10,
      searchLabelWidth: 120,
      placeholder: ' ',
      cascader: ['chargeType'],
      type: 'radio',
      order: 111,
      dicData: [
        {label: '是', value: 1},
        {label: '否', value: 0}
      ],
      value: 0,
      rules: [
        {required: true, message: '请选择是否周期性标准', trigger: 'change'}
      ],
      change: () => {
        self.form.chargeType = undefined
      }
    },
    {
      label: '计费方式',
      prop: 'chargeTypeInList',
      overHidden: true,
      width: 120,
      search: true,
      searchOrder: 20,
      display: false,
      type: 'select',
      dicUrl: process.env.VUE_APP_BASE_API + '/api/dict/CWSFBZ-JFFS',
      props: {
        label: 'name',
        value: 'code'
      },
      dicHeaders: {
        Authorization: getToken()
      },
      placeholder: ' '
    },
    {
      label: '计费方式',
      prop: 'chargeType',
      hide: true,
      placeholder: ' ',
      type: 'select',
      order: 110,
      dicUrl: process.env.VUE_APP_BASE_API + '/api/dict/CWSFBZ-JFFS',
      props: {
        label: 'name',
        value: 'code'
      },
      dicHeaders: {
        Authorization: getToken()
      },
      dicFormatter: (res) => {
        const {isPeriodic} = self.form
        const filter = isPeriodic ? ['CWSFBZ-JFFS-M1', 'CWSFBZ-JFFS-M2'] : ['CWSFBZ-JFFS-ONETIME']
        return res.data.filter(item => filter.includes(item.code))
      },
      rules: [
        {required: true, message: '请选择计费方式', trigger: 'blur'}
      ]
    },
    {
      label: '收费单价(元)',
      prop: 'chargeValue',
      overHidden: true,
      width: '120',
      order: 100,

      type: 'number',
      precision: 2,
      controls: false,
      min: 0,
      rules: [
        {required: true, message: '请输入收费单价', trigger: 'blur'}
      ]
    },
    {
      label: '启用日期',
      prop: 'startDate',
      overHidden: true,
      width: 120,

      type: 'date',
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd',
      order: 90,
      rules: [
        {required: true, message: '请选择启用日期', trigger: 'blur'}
      ]
    },
    {
      label: '停用日期',
      prop: 'endDate',
      overHidden: true,
      width: 120,

      type: 'date',
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd',
      value: '9999-12-31',
      clearable: false,
      order: 90,
      rules: [
        {required: true, message: '请选择停用日期', trigger: 'blur'}
      ]
    },
    {
      label: '启用折扣',
      width: '110',
      prop: 'enableDisaccount',
      overHidden: true,

      search: true,
      searchOrder: 10,
      placeholder: ' ',

      type: 'radio',
      dicData: [
        {label: '是', value: 1},
        {label: '否', value: 0}
      ],
      value: 0,
      order: 70,
      rules: [
        {required: true, message: '请选择是否启用折扣', trigger: 'blur'}
      ],
      control: (val, form) => {
        if (val == 0) {
          form.disaccountDate = undefined
          form.disaccountChargeRatio = undefined
          return {
            disaccountChargeRatio: {
              display: false
            },
            disaccountDate: {
              display: false
            }
          }
        } else {
          return {
            disaccountChargeRatio: {
              display: true
            },
            disaccountDate: {
              display: true
            }
          }
        }
      }
    },
    {
      label: '折扣有效期',
      prop: 'disaccountDate',
      overHidden: true,
      width: 140,
      formatter: (row) => {
        if (row.disaccountStartDate && row.enableDisaccount === 1) {
          return row.disaccountStartDate + '-' + row.disaccountEndDate
        }
      },

      type: 'daterange',
      display: true,
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd',
      order: 65,
      rules: [
        {required: true, message: '请选择折扣有效期', trigger: 'blur'}
      ]
    },
    {
      label: '折扣比例(%)',
      prop: 'disaccountChargeRatio',
      overHidden: true,
      width: '130',
      order: 50,
      formatter: (row) => {
        if (row.enableDisaccount === 1) {
          return row.disaccountChargeRatio
        }
      },
      type: 'number',
      precision: 2,
      display: true,
      controls: false,
      min: 0,
      max: 100,
      rules: [
        {required: true, message: '请输入折扣比例', trigger: 'blur'}
      ]
    },
    {
      label: '说明',
      prop: 'memo',
      hide: true,
      order: 40,

      type: 'textarea',
      rows: 3
    }
  ]
})
